import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root'
})
export class AppInterceptorService implements HttpInterceptor {
	isRefreshingToken = false;

	constructor(private router: Router, private apiService: ApiService) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let headers: any = {};
		let token: any = localStorage.getItem('simulation_token');
		if (req.url.indexOf("backend-content-storage.s3") >= 0) {
			if (token) {
				/* headers["x-auth-token"] = token; */
			}
		} else if (req.url.indexOf("refresh") == -1) {
			if (token) {
				/* headers["x-auth-token"] = token; */
				headers["Authorization"] = token;
			}
		} else {
			let simulation_refresh_token: any = localStorage.getItem('simulation_refresh_token');
			if (simulation_refresh_token) {
				headers["refresh_token"] = simulation_refresh_token;
			}
		}
		const httpRequest = req.clone({
			setHeaders: headers
		})
		return next.handle(httpRequest).pipe(tap({
			error: (err) => {
				if (err instanceof HttpErrorResponse) {
					if (err.status == 401) {
						if (req.url.indexOf("refresh") >= 0) {
							this.apiService.navigateToLogin(true);
						} else if (req.url.indexOf("login") < 0) {
							this.apiService.navigateToLogin(true);
						}
					}
				}
			}
		}));
	}
}
